import * as React from 'react';

import { breakpoints, theme } from '@notino/react-styleguide';

import { CdnImage } from '@components/CdnImage';
import { styled } from '@linaria/react';

import { LIST_THUMBNAIL_COUNT } from '../hooks/useListThumbnails';

const Wrapper = styled.div`
  grid-area: thumbnails;
  display: flex;
  gap: 0.75rem;
  justify-content: flex-start;
  height: 4rem;

  @media (min-width: ${breakpoints.md}) {
    justify-content: flex-end;
  }
`;

const Img = styled(CdnImage)`
  height: 4rem;
  width: 4rem;
  object-fit: contain;
`;

const MoreImagesCount = styled.div`
  color: ${theme.color.text.secondary};
  background-color: ${theme.color.background.secondary};
  ${theme.typography.labelRegular400}
  height: 4rem;
  width: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;

type Props = {
  productsCount: number;
  thumbnails: string[];
};

export const Thumbnails = ({ productsCount, thumbnails }: Props) => {
  const moreImagesCount = Math.max(productsCount - LIST_THUMBNAIL_COUNT, 0);

  return (
    <Wrapper>
      {thumbnails.map((url) => (
        <Img key={url} src={url} sourceKey="order" />
      ))}
      {!!moreImagesCount && (
        <MoreImagesCount>+{moreImagesCount}</MoreImagesCount>
      )}
    </Wrapper>
  );
};
